class JSONError extends Error {}

export default JSONError;